import React from 'react';

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  override componentDidCatch(error: unknown, errorInfo: unknown) {
    // TODO: send to Sentry once DSN configured
    console.error('ErrorBoundary caught error', error, errorInfo);
  }

  override render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center text-text">
          <h1 className="mb-4 text-2xl font-semibold">Something felt off.</h1>
          <p className="mb-6 text-sm text-textMuted">
            The app ran into an issue. You can close and reopen Newrotune to reset.
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

